/* Tia Lorens home — tabovi proizvoda */
(function () {
  function initTabs(root) {
    if (root.dataset.tlInit) return; root.dataset.tlInit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        // Dawn reveal: elementi u skrivenom panelu su bili "offscreen" — prikaži ih odmah
        panels[i].querySelectorAll('.scroll-trigger--offscreen').forEach(function (el) {
          el.classList.remove('scroll-trigger--offscreen');
        });
      });
    });
  }
  function init() { document.querySelectorAll('[data-tl-tabs]').forEach(initTabs); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Mobilni hero slajder: tačkice + auto-listanje */
(function () {
  function initHero(root) {
    if (root.dataset.tlInit) return; root.dataset.tlInit = '1';
    var track = root.querySelector('.tl-mhero__track'), dots = root.querySelector('.tl-mhero__dots');
    var slides = Array.prototype.slice.call(track.children); if (slides.length < 2) return;
    slides.forEach(function (_, i) { var d = document.createElement('i'); if (i === 0) d.className = 'is-on'; dots.appendChild(d); });
    var idx = 0, timer = null, delay = (parseInt(root.dataset.autoplay, 10) || 0) * 1000;
    function setDot(i) { Array.prototype.forEach.call(dots.children, function (d, j) { d.className = j === i ? 'is-on' : ''; }); }
    track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) { idx = i; setDot(i); } }, { passive: true });
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function start() { if (!delay) return; stop(); timer = setInterval(function () { go((idx + 1) % slides.length); }, delay); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    track.addEventListener('touchstart', stop, { passive: true }); track.addEventListener('touchend', function () { setTimeout(start, 6000); }, { passive: true });
    if (window.matchMedia('(max-width: 749px)').matches) start();
  }
  function init() { document.querySelectorAll('[data-tl-mhero]').forEach(initHero); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
